import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERY, useResponsive } from '@bucketplace/design-system';
import { CarouselScrollControl } from '@bucketplace/design-system/bds';

import { ExhibitionProductCard } from '../ExhibitionProductCard';
import { ExhibitionList } from './types';

export function CarouselList({
  disableVerticalPadding,
  storeItemList,
  badgeType,
  useBuyButton,
  logData,
}: ExhibitionList): ReactElement {
  const { breakpoint } = useResponsive({});
  const isMobile = breakpoint === 'mobile';

  return (
    <StyledCarouselScrollControl
      disableVerticalPadding={disableVerticalPadding}
      gap={isMobile ? 12 : 18}
      gradation={false}
      fixed
    >
      { storeItemList.map((storeItem, index) => (
        <ExhibitionProductCard
          key={storeItem.id}
          product={storeItem}
          badgeType={badgeType}
          textBadgeList={storeItem.textBadgeList}
          useBuyButton={useBuyButton}
          variant={isMobile ? 'md' : 'lg'}
          href={storeItem.getStoreItemHref?.(storeItem.id)}
          linkComponent={storeItem.linkComponent}
          logData={{
            ...logData,
            index,
          }}
        />
      )) }
    </StyledCarouselScrollControl>
  );
}

const StyledCarouselScrollControl = styled(CarouselScrollControl, {
  shouldForwardProp: (prop) => prop !== 'disableVerticalPadding',
})<{ disableVerticalPadding?: boolean }>`
  ul {
    width: 100%;
    margin: ${(props) => props.disableVerticalPadding ? 0 : '20px 0'};
  }
  li {
    ${({ gap = 1 }) => css`
      width: ${`calc(25% - ${gap}px + ${gap / 4}px)`};
    `}
    max-width: 173px;
  }
  ${MEDIA_QUERY.max('tablet', css`
    li {
      width: 33%;
      min-width: 134px;
    }
    li:first-of-type, li:last-of-type {
      width: calc(33% + 16px);
      min-width: calc(134px + 16px);
      max-width: calc(173px + 16px);
    }
    li:first-of-type {
      padding-left: 16px;
    }
    li:last-of-type {
      padding-right: 16px;
    }
  `)}
`;
